<template>
    <section class="accounts-users-modal">
        <header class="account-users-header">
            <h3>Users for "{{company}}"</h3>
            <div @click="closeModal" class="account-users-close-btn clickable">X</div>
        </header>
        <div class="accounts-users-table-wrap">
            <table class="accounts-users-table">
                <thead class="accounts-users-table-head">
                    <tr>
                        <th class="accounts-users-table-header" title v-for="column in columnHeaders">
                            <span v-html="column"></span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                <tr class="accounts-users-table-row" v-for="user in users" :key="user.id">
                    <td>
                        <div v-if="user.plunetid" class="account-users-name">
                            <a target="_blank" :href="plunetLink + user.plunetid"><span v-text="user.firstname + ' ' + user.lastname"></span></a>
                        </div>
                        <div v-else class="account-users-name" v-text="user.firstname + ' ' + user.lastname"></div>
                        <div class="account-users-role" v-html="user.role"></div>
                    </td>
                    <td>
                        <div style="min-width:71px;">
                            <input @change="toggleUserAcclaroPortal(user)" v-model="user.portalenable" type="checkbox">
                            <span v-if="user.portalenable">Enabled</span>
                            <span v-else>Disabled</span>
                        </div>
                    </td>
                    <td>
                        <select @change="setPasswordState(user)" v-model="user.passwdstate">
                            <option>activated</option>
                            <option>reset</option>
                        </select>
                        <div v-if="user.passwdstate == 'reset'">
                          <button @click="inviteUser(user)" class="reset-user-btn">Invite</button>
                        </div>
                    </td>
                    <td>
                        <button class="become-user-btn" @click="showImpersonationDialog(user)" type="button">Become User</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <footer class="account-users-footer">
            <a href="/admin/users"><span>View Account Users Page</span></a>
        </footer>
        <notifications group="foo" />
    </section>
</template>

<script>
import './account-users-modal.scss';

const ACCOUNT_USER_BASE_URL = '/admin/menuclick';

export default {
    name: "AccountUsersModal",

    props: {

        company: {
          type: String,
          default: ''
        },

        users: {
          type: Array,
          default: function () {
              return [];
          }
        }
    },

    computed: {},

    methods: {

        closeModal () {
          this.$emit('close-modal');
        },

        showImpersonationDialog (user) {
          this.$emit('impersonate-modal', {user});
        },

        sendInvite (user) {
          let params = {
            op: 'send',
            uid: user.id
          };

          axios.get('/admin/view-invite', {params}).then(result => {
            this.$modal.hide('dialog');

            if (result.data.includes('Sent')) {
              this.showSuccesfulInvite();
            }
          })
        },

        showInviteDialog (result, user) {
          this.$modal.show('dialog', {
            title: `Invite`,

            //we are removing the 'or send email invitation' function
            //from returned html.
            //@TODO - replace the legacy code here
            text: result.data.split('Or ')[0],
            buttons: [
              {
                title: 'Send Email Invitation',
                class: 'vue-dialog-button reviewer-dialog-btn close-btn',
                handler: () => this.sendInvite(user)
              }
            ]
          });
        },

        inviteUser (user) {
          let params = {
            u: `aapdw${user.id}`
          };

          return axios.get('/admin/view-invite', {params}).then(result => {
            this.showInviteDialog(result, user);
          });
        },

        setPasswordState (user) {
          let params = {
            t: `aapdw${user.id}dd`,
            v: user.passwdstate,
          };

          return axios.get(ACCOUNT_USER_BASE_URL, {params})
            .then(result => {
              if(result.data) {
                console.error('Account User Error: failed to update users password state');
              }
            })
        },

        toggleUserAcclaroPortal (user) {
            let userId = user.id;
            let activeState = user.portalenable ? 'Enabled' : 'Disabled';

            return axios.get(ACCOUNT_USER_BASE_URL, {
                params: {
                  t: `aapdp${userId}dd`,
                  v: activeState
                }
            }).then(result => {
              if(result.data) {
                console.error('Account User Error: failed to update user portal access');
              }
            })
        },

        showSuccesfulInvite () {
          console.log('notifying');
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Your invite has been sent',
            text: `Invite sent successfully!`,
            duration: 1000,
            speed: 1000,
            animation: {
              enter: { height: 200, opacity: 1, top: '10%', left: '10%' },
              leave: { height: 0, opacity: 0, top: '10%', left: '10%'}
            },
            data: {}
          })
        }
    },

    data () {

        return {
            //@TODO - get correct plunet link
            plunetLink: 'https://plunetqa1.acclaro.com/pagesUTF8/partner_kunde.jsp?OSGO1=0#AP',
            columnHeaders: [
                'Name/Role',
                'Acclaro',
                'Password',
                '',
            ]
        }
    }
}
</script>
